import { IProduct, IProductWholesale, IWholesalePrice } from 'mod/product/interface';
import { IVariant } from 'base/interfaces/product';

export function getWholesaleRangeIndex(list: IWholesalePrice[], qty: number): number {
    let index = 0;
    let minQty = 1;
    list.forEach((item, idx) => {
        if (qty >= item.minQuantity && minQty <= item.minQuantity) {
            minQty = item.minQuantity;
            index = idx
        }
    });
    return index;
}

export function hasWholeSalePrice(product: IProductWholesale): boolean {
    return !product.wholesalePrices.find(item => item.minQuantity === 0)
}

export function getUnitsRange({ maxQuantity, minQuantity }: IWholesalePrice): string {
    if (maxQuantity === 0) {
        return `>=${minQuantity}`;
    }
    if (maxQuantity > minQuantity) {
        return `${minQuantity}-${maxQuantity}`
    }
    return `${minQuantity}`
}

export function getWholesalePriceExchange(product: IVariant): number {
    return product.dealPriceExchangeDisplay ?
        product.dealPriceExchange
        : product.shopPriceExchange
}

export function getWholesalePriceExchangeDisplay(product: IVariant): string {
    return product.dealPriceExchangeDisplay || product.shopPriceExchangeDisplay;
}

export function getSuggestedPriceExchange(product: IVariant): number {
    return product.dealPriceExchangeDisplay
        ? product.shopPriceExchange
        : (product.dealPriceExchange || product.shopPriceExchange);
}

export function getSuggestedPriceExchangeDisplay(product: IVariant): string {
    return product.dealPriceExchangeDisplay
        ? product.shopPriceExchangeDisplay
        : (product.dealPriceExchangeDisplay || product.shopPriceExchangeDisplay);
}


